const isTouchDevice = () => {
    return 'ontouchstart' in window
}

const each = (value, callback) => {
    if (!value || !(value instanceof Object) || typeof callback !== 'function') {
        return
    }
    for (const key in value) {
        callback(value[key], key)
    }
}

const scrollToElement = (element, offset = 0, effect = 'smooth') => {
    let searchedEl
    if (!element) {
        scrollToTop()
        return
    }
    if (element instanceof HTMLElement) {
        searchedEl = element
    }
    if (typeof element === 'string') {
        searchedEl = document.querySelector(element)
    }
    if (!searchedEl) { return }
    const targetPosition = parseInt(searchedEl.getBoundingClientRect().top + window.pageYOffset + offset, 10)
    window.scrollTo({ top: targetPosition, behavior: effect })

    return new Promise(resolve => {
        const scrollHandler = () => {
            if (window.pageYOffset === targetPosition) {
                window.removeEventListener('scroll', scrollHandler)
                resolve()
            }
        }
        window.addEventListener('scroll', scrollHandler)
    })
}

const scrollToTop = (delay) => {
    if (typeof delay !== 'number') {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
        return
    }
    setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    }, delay)
}

const generateUuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

const deepExtend = (value, dest, key) => {
    if (value instanceof Array) {
        const newArr = []
        value.forEach((arrValue, index) => {
            deepExtend(arrValue, newArr, index)
        })
        addResult(newArr)
    } else if (value instanceof Date) {
        addResult(new Date(value))
    } else if (value instanceof Object) {
        const newObj = {}
        for (const key2 in value) {
            deepExtend(value[key2], newObj, key2)
        }
        addResult(newObj)
    } else {
        addResult(value)
    }
    return dest

    function addResult(result) {
        if (typeof dest === 'undefined') {
            dest = result
        } else {
            dest[key] = result
        }
    }
}

const removeNullAndEmptyValuesFromObject = (obj) => {
    obj = obj || {}
    const newObject = deepExtend(obj)
    Object.keys(newObject).forEach((key) => ((newObject[key] === null) || (newObject[key] === undefined) || (Array.isArray(newObject[key]) && !newObject[key].length) || (typeof newObject[key] === 'string' && !newObject[key].length)) && delete newObject[key])
    return newObject
}

const addParamsToLocation = (params) => {
    params = removeNullAndEmptyValuesFromObject(params)
    history.pushState(
        {},
        null,
        document.location.pathname + '?' + Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&')
    )
}

module.exports = {
    isTouchDevice,
    each,
    scrollToElement,
    scrollToTop,
    generateUuid,
    deepExtend,
    removeNullAndEmptyValuesFromObject,
    addParamsToLocation
}
